module.exports = __webpack_public_path__ + "img/cart.38f80929.png";